const _contrast = (x,y)=>x===y
export function checker(source=[], contrast=_contrast){
    let checkedList = []
    
    const vague = ()=>checkedList.length > 0 && source.length !== checkedList.length

    function checkAll(){
        checkedList = [...source]
    }

    function invert(checkedList=checkedList){
        const _invert = source.filter(sItem=>!contrast(sItem, checkedList.find(cItem=>contrast(sItem, cItem))))
        return _invert
    }

    function clear(){
        checkedList.splice(0, checkedList.length)
    }

    function checked(item){
        if(checkedList.find(cItem=>contrast(cItem, item))) return false
        checkedList.push(item)
    }

    function unchecked(item){
        if(!checkedList.find(cItem=>contrast(cItem, item))) return false
        checkedList.splice(checkedList.findIndex(cItem=>contrast(cItem, item)), 1)
    }

    const context = {
        //operator
        vague,
        checkAll,
        invert,
        clear,
        checked: (item, _checked=true)=> _checked ? checked(item) : unchecked(item)
    }

    Object.defineProperties(context, {
        "checkedList":{
            get(){
                return checkedList
            }
        },
        "source": {
            get(){
                return source
            },
            set(val){
                source = val
            }
        }
    })

    return Object.freeze(context)
}